import translations from 'app/features/localization/translations.json';
import { HERO } from 'app/analytics/constants/positions';
import { HOME_SELECTED } from 'app/features/header/actionTypes';
import { commonActionDetail } from 'app/analytics/selectors';
import { actionDetail } from 'app/analytics/helpers';

const homeButton = {
  [HOME_SELECTED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Home Selected',
    properties: actionDetail({
      position: HERO,
      textOfButtonOrLink: translations.buttons_take_me_home,
      ...commonActionDetail(getState()),
      ...payload,
    }),
  }),
};

export default homeButton;
